module.exports = __webpack_public_path__ + "static/media/14.05528c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/14.png
// module id = 1452
// module chunks = 0